export default __webpack_public_path__ + "img/0d1b6b19c47f11c1779c414aa0f9e6de.svg";